import { Flex, Spin } from 'antd'
import { Cluster } from 'src/types/type'

import ClusterDetails from './ClusterDetails'
import CorrelationDetails from './CorrelationDetails'

type GradeDetailsPageProps = {
  selectedCluster: Cluster | null
  grade: string | string[]
  checkedModulesAndClusters: {
    [key: string]: boolean
  }
  handleCheckboxChange: (moduleName: string) => void
  selectedCorrelation: Cluster | null
  getModuleContent: (moduleSlug: string) => JSX.Element
}

function GradeDetailsPage({
  selectedCluster,
  grade,
  checkedModulesAndClusters,
  handleCheckboxChange,
  selectedCorrelation,
  getModuleContent
}: GradeDetailsPageProps) {
  return (
    <Flex gap="8px" align="start" className="grade-details-page">
      {selectedCluster && selectedCorrelation ? (
        <>
          <ClusterDetails
            selectedCluster={selectedCluster}
            selectedGrade={grade}
            checkedModulesAndClusters={checkedModulesAndClusters}
            handleCheckboxChange={handleCheckboxChange}
            getModuleContent={getModuleContent}
          />
          <CorrelationDetails
            selectedCorrelation={selectedCorrelation}
            getModuleContent={getModuleContent}
          />
        </>
      ) : (
        <Spin />
      )}
    </Flex>
  )
}
export default GradeDetailsPage
